import classNames from "classnames";
import { Controller } from "react-hook-form";

const TextNumberInput = ({
  control,
  name,
  required,
  errorMsg,
  pattern,
  patternErrorMsg,
  type,
  isDirty,
  labels,
  readOnlyMode,
  minLength,
  maxLength,
  trim,
  customPh,
  onFocus,
}) => {
  const handleChange = (e, controlledOnChange) => {
    const value = e.currentTarget.value;
    controlledOnChange(
      maxLength
        ? trim
          ? value.slice(0, maxLength)?.trim()
          : value.slice(0, maxLength)
        : trim
        ? value?.trim()
        : value
    );
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: { value: required, message: errorMsg },
        ...(pattern ? { pattern: { value: pattern, message: patternErrorMsg } } : {}),
      }}
      render={({ field: { onChange: controlledOnChange, value, ...others } }) => (
        <input
          {...others}
          type={type}
          id={name}
          className={classNames(
            `form__input form__input--${type}`,
            isDirty && "form__input--dirty"
          )}
          placeholder={
            customPh || labels?.[`WELFARE_${type.toUpperCase()}_PLACEHOLDER`] || "Type your answer"
          }
          value={value || ""}
          onChange={(e) => handleChange(e, controlledOnChange)}
          disabled={readOnlyMode}
          minLength={minLength}
          maxLength={maxLength}
          onFocus={onFocus}
        />
      )}
    />
  );
};

export default TextNumberInput;
